import React, { useCallback, useContext, useEffect, useState } from 'react';

import api from '../api';
import { Context as AuthContext } from '../../auth/context';
import { Provider as name } from '../config';
import { useGet, useGetById, useGetSchema, usePost, usePut } from '../../apiHooks';
import { Client } from '../model';

import Context from './context';

interface Props {
    children: React.ReactNode;
}

const ClientsProvider: React.FC<Props> = (props: Props) => {
    const { children } = props;

    const [data, setData] = useState<Array<Client>>([]);
    const [schema, setSchema] = useState({});
    const [selected, setSelected] = useState<Client | {}>({});
    const [error, setError] = useState({});

    const getById = useGetById(api, selected, setSelected, setError);

    const handleGetData = useCallback((res) => {
        setData(res);
        return res;
    }, []);
    const get = useGet(api, data, handleGetData, setError);

    const getSchema = useGetSchema(api, schema, setSchema, setError);

    const selectedClientId = (selected as Client)?._id;
    const handleSetData = useCallback(
        (item, newData) => {
            setData(newData);
            if (item?._id === selectedClientId) {
                setSelected(item);
            }
        },
        [selectedClientId]
    );
    const post = usePost(api, data, handleSetData, setError);

    const put = usePut(api, data, handleSetData, setError);

    const authContext = useContext(AuthContext);
    // Synchronizes the current logged in user with the selected client
    useEffect(() => {
        const clientId = authContext.user?.[0]?.clientId;
        if (clientId) {
            getById(clientId).then((selectedClient: Client | null) => {
                if (!selectedClient) {
                    throw new Error('Invalid client!');
                }
                setSelected(selectedClient);
            });
        } else {
            setSelected({});
        }
    }, [authContext.user]); // eslint-disable-line

    return (
        <Context.Provider
            value={{
                name,
                get,
                getById,
                getSchema,
                schema,
                post,
                put,
                data,
                setData,
                selected,
                setSelected,
                error
            }}
        >
            {children}
        </Context.Provider>
    );
};

export default ClientsProvider;
